import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useUserStore = defineStore(
  'user', 
  () => {
    const user = ref(null)
    const isAdmin = computed(() => ['ADMIN', 'E'].includes(user.value?.authGrpId))
    const isExecutive = computed(() => user.value?.authGrpId === 'E')
    const getToken = computed(() => user.value?.token)
    const dashboardOptions = ref(null)
    function setUser(data) {
      user.value = data
    }
    function setDashboardOptions(data) {
      dashboardOptions.value = data
    }
    return { user, isAdmin, isExecutive, getToken, setUser, dashboardOptions, setDashboardOptions }
  },
  {
    persist: { key:'user', storage:sessionStorage },
  },
)